<template>
  <div class="space-y-8">
    <div class="grid gap-3">
      <button
        v-for="option in options"
        :key="option.value"
        @click="select(option.value)"
        :class="[
          'btn btn-lg w-full rounded-xl font-medium transition-all duration-200',
          selected === option.value 
            ? 'btn-primary shadow-lg' 
            : 'btn-outline hover:bg-base-200'
        ]">
        {{ $t(option.label) }}
      </button>
    </div>

    <button 
      class="btn btn-primary btn-lg w-full rounded-xl font-medium disabled:opacity-50" 
      :disabled="!selected" 
      @click="$emit('next')">
      {{ $t("smartLeadForm.next") }}
    </button>
  </div>
</template>

<script lang="ts" setup>
import { ref, watch } from "vue";
import type { Answers } from "@/features/blueprint/schema/answers/Answers";

const props = defineProps<{ modelValue: Answers }>();
const emit = defineEmits(["update:modelValue", "next"]);

const selected = ref(typeof props.modelValue.timeline === "string" ? props.modelValue.timeline : "");

const options = [
  { value: "now", label: "smartLeadForm.timeline.options.now" },
  { value: "soon", label: "smartLeadForm.timeline.options.soon" },
  { value: "exploring", label: "smartLeadForm.timeline.options.exploring" },
];

watch(selected, val => {
  emit("update:modelValue", {
    ...props.modelValue,
    timeline: val,
  });
});

function select(value: string) {
  selected.value = value;
}
</script>